module.exports = __webpack_public_path__ + "img/21.228095e2.png";